import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next";
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import i18n from "i18next";
import Cookies from "js-cookie";
import logo from "../img/logo.svg";
import logo_mob from "../img/logo.svg";
import MobileMenu from "./MobileMenu";
import { LinkContext } from "../LinkProvider";
import { useContext } from "react";

function Header() {

    const { link } = useContext(LinkContext);

    const { t } = useTranslation();
    const location = useLocation();

    const languages = [
        { value: 'en', label: 'EN' },
        { value: 'ru', label: 'RU' },
        { value: 'pl', label: 'PL' },
        { value: 'de', label: 'DE' },
    ]

    const storedLang = Cookies.get("i18next");
    const [currentLang, setCurrentLang] = useState(storedLang || 'en');

    useEffect(() => {
        if (storedLang && storedLang !== currentLang) {
            setCurrentLang(storedLang);
            i18n.changeLanguage(storedLang);
        }
        // eslint-disable-next-line
        document.body.setAttribute('dir', storedLang === 'ar' ? 'rtl' : 'ltr');
    }, [storedLang]);
    

    const handleChangeLang = (selectedLang) => {
        setCurrentLang(selectedLang.value);
        i18n.changeLanguage(selectedLang.value);
        Cookies.set("i18next", selectedLang.value);
    };

    return (
        <div className="fixed top-0 left-0 w-full bg-[#0F0229] z-[1000]">
            <div className="hidden max-w-[1220px] h-[56px] justify-between mx-auto xl:flex items-center">
                <div className="flex items-center justify-between w-full">
                    <Link to="/"><img src={logo} alt="" className="h-[40px]"/></Link>
                    <div className="flex items-center gap-[40px]">
                        <Link to="/products"><p className={`text-[14px] hover:scale-[1.1] roboto transition-all ${location.pathname === '/products' ? 'font-[500] text-[#65CDBF]' : 'text-[#FFF]'}`}>{t('header.1')}</p></Link>
                        <Link to="/investment"><p className={`text-[14px] hover:scale-[1.1] roboto transition-all ${location.pathname === '/investment' ? 'font-[500] text-[#65CDBF]' : 'text-[#FFF]'}`}>{t('header.2')}</p></Link>
                        <Link to="/accounttypes"><p className={`text-[14px] hover:scale-[1.1] roboto transition-all ${location.pathname === '/accounttypes' ? 'font-[500] text-[#65CDBF]' : 'text-[#FFF]'}`}>{t('header.account')}</p></Link>
                        <Link to="/ambassador"><p className={`text-[14px] hover:scale-[1.1] roboto transition-all ${location.pathname === '/ambassador' ? 'font-[500] text-[#65CDBF]' : 'text-[#FFF]'}`}>{t('header.3')}</p></Link>
                        <Link to="/about"><p className={`text-[14px] hover:scale-[1.1] roboto transition-all ${location.pathname === '/about' ? 'font-[500] text-[#65CDBF]' : 'text-[#FFF]'}`}>{t('header.4')}</p></Link>
                        <Link to="/contact"><p className={`text-[14px] hover:scale-[1.1] roboto transition-all ${location.pathname === '/contact' ? 'font-[500] text-[#65CDBF]' : 'text-[#FFF]'}`}>{t('header.5')}</p></Link>
                    </div>
                    <div className="flex items-center gap-[20px]">
                        <Dropdown
                            options={languages}
                            placeholder="EN"
                            onChange={handleChangeLang}
                            value={languages.find(lang => lang.value === currentLang)}
                        />
                        <a href={link}>
                            <div className="butt hover:scale-[1.1] transition-all">
                                <p className="roboto text-[14px] uppercase text-white py-[8px] px-[18px]">{t('header.button')}</p>
                            </div>
                        </a>
                    </div> 
                </div>
                
            </div>
            <div className="xl:hidden flex mx-[20px] items-center justify-between h-[56px]">
                <Link to="/"><img src={logo_mob} alt="" className="h-[40px]"/></Link>
                <Dropdown
                    options={languages}
                    placeholder="EN"
                    onChange={handleChangeLang}
                    value={languages.find(lang => lang.value === currentLang)}
                    className="ml-auto mr-[20px]"
                />
                <MobileMenu/>
            </div>
        </div>
    );
}

export default Header;
